import { render, staticRenderFns } from "./consent-import-preview-table.vue?vue&type=template&id=1cea1b16&"
import script from "./consent-import-preview-table.vue?vue&type=script&lang=js&"
export * from "./consent-import-preview-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports